import { useTranslation } from "react-i18next";
import styles from "./EnergyProfileWelcomePage.module.scss";
import sharedStyles from "../../../../../styles/WelcomePage.module.scss";
import { ChartIcon, DashboardLowIcon, EnergyProfileWelcomeImage, PeopleAddIcon } from "../../../../../assets/icons";
import { BenefitRow } from "../../../../../common/components/benefits-row/BenefitRow";
import CustomerPageLayout from "../../../customer-page-layout/CustomerPageLayout";
import { useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../../../routes";

interface EnergyProfileWelcomePageProps {
	/** When embedded inside the sign-up flow: render bare (no page layout) and
	 * show the two-CTA variant (Set Up / Skip), calling the callbacks below
	 * instead of navigating to the settings route. */
	embedded?: boolean;
	onContinue?: () => void;
	onSkip?: () => void;
}

export const EnergyProfileWelcomePage = ({ embedded = false, onContinue, onSkip }: EnergyProfileWelcomePageProps) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleContinue = () => {
		if (onContinue) {
			onContinue();
			return;
		}
		navigate(`/${ApplicationRoutes.SETTINGS}/${ApplicationRoutes.ENERGY_PROFILE_CREATE}`);
	};

	const body = (
		<div className={`${sharedStyles.screen} ${embedded ? styles.embeddedScreen : ""}`}>
			<EnergyProfileWelcomeImage className={`${sharedStyles.image} ${embedded ? styles.embeddedImage : styles.imageMargin}`} />
			<h1 className={sharedStyles.title}>{t("common.labels.energyProfileWelcomeTitle")}</h1>
			<p className={sharedStyles.description}>{t("account.web.energyProfileWelcomeSubtitle")}</p>
			<div className={`${sharedStyles.benefitsContainer} ${embedded ? styles.embeddedBenefits : ""}`}>
				<BenefitRow badge="" title={t("common.labels.energyProfileWelcomeUsageTracking")} description={t("account.web.usageTrackingDescription")} leftIcon={<ChartIcon />} />
				<BenefitRow
					badge=""
					title={t("common.labels.energyProfileWelcomePerformanceMonitoring")}
					description={t("account.web.performanceMonitoringDescription")}
					leftIcon={<DashboardLowIcon />}
				/>
				<BenefitRow badge="" title={t("common.labels.energyProfileWelcomeAccountDetails")} description={t("account.web.accountDetailsDescription")} leftIcon={<PeopleAddIcon />} />
			</div>
			{embedded ? (
				<>
					<button className={`${sharedStyles.continueBtn} ${styles.embeddedContinueBtn}`} onClick={handleContinue}>
						{t("auth.setUpEnergyProfile")}
					</button>
					<button type="button" className="app-secondary-btn" style={{ marginTop: 12, width: "100%" }} onClick={onSkip}>
						{t("auth.skipForNow")}
					</button>
				</>
			) : (
				<button className={`${sharedStyles.continueBtn} ${styles.continueBtnMargin}`} onClick={handleContinue}>
					{t("common.actions.continueKey")}
				</button>
			)}
		</div>
	);

	if (embedded) return body;

	return (
		<CustomerPageLayout title="" showBackButton={true} contentMaxWidth={1200} isScrollable>
			{body}
		</CustomerPageLayout>
	);
};
